import { __require as requireHowler } from '../node_modules/.pnpm/howler@2.2.4/node_modules/howler/dist/howler.js';

var howlerExports = requireHowler();

export { howlerExports as h };
//# sourceMappingURL=howler.js.map
